import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthActions } from '@shared/store/auth/auth.actions';
import { debounceTime, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ApplicationSelectors } from '@shared/store/application/application.selectors';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    standalone: false
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  public menuCollapse: boolean = this.store.selectSnapshot(ApplicationSelectors.sideMenu);

  private subscription: Subscription = new Subscription();

  public sideMenuVisible: boolean = true;

  constructor(private readonly store: Store,
              private readonly router: Router) {
    this.subscribeWindowSize();
    this.subscribeRouterEvents();
    this.subscribeSideMenuVisibility();
  }

  ngOnInit(): void {
    this.store.dispatch(AuthActions.GetCurrentLogged);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // controls menu collapse depending on window width
  private subscribeWindowSize(): void {
    this.subscription.add(
      this.store.select(ApplicationSelectors.isMobileMode).subscribe(
        (value: boolean) => {
          this.menuCollapse = value;
        }
      )
    );
  }

  // manage closing mobile menu when redirect
  private subscribeRouterEvents(): void {
    this.subscription.add(
      this.router.events.pipe(
        filter(event => event instanceof NavigationStart)
      ).subscribe(() => {
        this.menuCollapse = this.store.selectSnapshot(ApplicationSelectors.isMobileMode);
      })
    );
  }

  private subscribeSideMenuVisibility(): void {
    this.subscription.add(this.store.select(ApplicationSelectors.sideMenu)
      .pipe(
        debounceTime(10)
      )
      .subscribe((visible: boolean) => {
        this.sideMenuVisible = visible;
      }));
  }

}
